import React from 'react';
import { connect } from 'react-redux';
import { Trans, withTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { hasShowHmdaDisclosure } from 'app/models/fields/conditionals';
import { getFormValues } from 'redux-form';
import { getFormType } from 'app/routes/helpers';

type Props = ReturnType<typeof mapStateToProps>;

const DisclosureComponent = ({ ...props }: Props) => {
  const { values } = props;
  const showGovernmentMonitoring = hasShowHmdaDisclosure(values);
  return (
    showGovernmentMonitoring ? (
      <Grid container>
        <Grid item xs={12}>
          <Typography paragraph={true}></Typography>
        </Grid>
        <Grid container classes={{ container: 'indent' }}>
          <Grid item xs={12}>
            <Typography variant='body2'>
              <Trans i18nKey='disclosure.paragraph1'> </Trans>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    ) : null
  );
};

const mapStateToProps = (state: any) => ({
  values: getFormValues(getFormType(state.router.location.pathname))(state),
});

export const Disclosure = connect(
  mapStateToProps,
  null,
)(withTranslation()(DisclosureComponent));
